module.exports = __webpack_public_path__ + "assets/img/全球鹰演艺.911d05b1.png";